import { ButtonProps } from "@chakra-ui/react";
import {
  AccountSubType,
  ActivityTypeName,
} from "@syla/shared/types/models/AccountBase";
import React from "react";
import { StandardSelectOption } from "../../components/selector/parts/SelectOption";
import { SingleSelector } from "../../components/selector/SingleSelector";

export function AccountSubtypeSelector({
  currentValue,
  onSelected,
  isLoading,
  isDisabled,
  ...props
}: {
  currentValue: AccountSubType | undefined;
  onSelected: (value: AccountSubType) => void;
  isLoading?: boolean;
  isDisabled?: boolean;
} & ButtonProps) {
  const values = Object.values(AccountSubType);

  const options: StandardSelectOption<AccountSubType>[] = values.map(
    (role) => ({
      value: role,
      data: {
        label: ActivityTypeName[role],
        description: ActivityTypeDescription[role],
      },
    }),
  );

  return (
    <SingleSelector
      options={options}
      value={currentValue}
      onChange={onSelected}
      isLoading={isLoading}
      isDisabled={isDisabled}
      buttonProps={props}
    />
  );
}

export const ActivityTypeDescription: Record<AccountSubType, string> = {
  [AccountSubType.Investor]: "Treats crypto as capital gains and losses.",
  [AccountSubType.Trader]: "Treats crypto as trading stock.",
};
